export const generateReconciliationType = (reconciliationTypes) => {
  return reconciliationTypes.map((type) => ({
    value: type.id,
    text: type.name,
    disabled: false,
  }));
};
